<ng-container *ngIf="itemMessage; else redirecting">
    <h3 class="alert alert-danger">{{itemMessage}}</h3>
</ng-container>
<ng-template #redirecting>
    <h3 class="alert alert-light">redirecting to action page...</h3>
</ng-template>
